var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-app",attrs:{"id":"app"}},[(_vm.allColors.length <= 0)?_c('loading-text'):_c('div',{staticClass:"flex min-w-full min-h-full"},[_c('Navbar',{on:{"copyAlert":function (e) {
          this$1.show = e
        }}}),_c('CopyAlertVue',{staticClass:"absolute-center z-50 w-64 h-44",attrs:{"alertMessage":"✔ Copied All Colors!","triggerAlert":_vm.show},on:{"hideAlert":function (e) {
          this$1.show = e
        }}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }